<div class="modal-header" id="yes-no-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.title }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col" [innerHTML]="model.message"></div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary me-auto" *ngIf="model.cancelMessage" (click)="onCancelClick()">
        {{ model.cancelMessage }}
    </button>
    <button class="btn btn-secondary customNoClass" *ngIf="model.noMessage" (click)="onNoClicked()">
        {{ model.noMessage }}
    </button>
    <button class="btn btn-primary" *ngIf="model.showYes" (click)="onYesClicked()">{{ model.yesMessage }}</button>
</div>
